var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositnft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 22.6667L3.49475 25.98C3.63895 26.5569 3.97185 27.0691 4.44052 27.4351C4.9092 27.8011 5.48676 27.9999 6.08141 28H25.9187C26.5134 27.9999 27.091 27.8011 27.5596 27.4351C28.0283 27.0691 28.3612 26.5569 28.5054 25.98L29.3334 22.6667M16.0001 20V4V20ZM16.0001 20L10.6667 14.6667L16.0001 20ZM16.0001 20L21.3334 14.6667L16.0001 20Z",
    stroke: "#3889FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositnft);
export default __webpack_public_path__ + "static/media/depositnft.a85f32b8.svg";
export { ForwardRef as ReactComponent };